// extracted by mini-css-extract-plugin
var _1 = "CanvasBubble_active__9787f";
var _2 = "CanvasBubble_content__afb9e";
var _3 = "CanvasBubble_count__927d6";
var _4 = "CanvasBubble_newDot__7cec4";
var _5 = "CanvasBubble_resolved__04487";
var _6 = "CanvasBubble_root__3baf8";
export { _1 as "active", _2 as "content", _3 as "count", _4 as "newDot", _5 as "resolved", _6 as "root" }
